

















import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  name: 'SettingsUser',
  data: () => ({
    confirmNewPasswordSnack: false,
    user: {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
    },
    validForm: false,
    rules: {
      requiredLength: (value: {}[]) => value.length > 1 || 'Délka hesla je minimálně 4 znamky',
    },
  }),
  mounted() {
    //const form: any = this.$refs.passwordForm;
    (this.$refs.passwordForm as Vue & { validate: () => boolean }).validate();
  },
  methods: {
    changePassword() {
      //const form: any = this.$refs.passwordForm;
      if ((this.$refs.passwordForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Špatne zadané původní heslo');
      } else {
        // const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
        if (this.user.newPassword === this.user.newPasswordConfirm) {
          /*if (strongRegex.test(this.user.newPassword) === false) {
            this.notifyMessage = 'Password does not meet security policy';
            return;
          }*/
          axios
            .post('/api/v1/changepassword', this.user)
            .then((response) => {
              switch (response.data.message) {
                case 'wrongOldPassword':
                  this.$store.commit('globalMessage', 'Špatne zadané původní heslo');
                  break;
                default:
                  this.user.oldPassword = '';
                  this.user.newPassword = '';
                  this.user.newPasswordConfirm = '';
                  this.confirmNewPasswordSnack = true;
              }
            })
            .catch((err) => {
              console.log('err', err);
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          this.$store.commit('globalMessage', 'Heslo a potvrzení hesla se neshodují');
        }
      }
    },
  },
});
